export const CalendarCellType = {
  vacant: 0,
  few: 2,
  unavailable: 1
}
